/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum OralDietViewerAliases {
  EXECUTE_TIME_BUTTON = 'execute-time-button',
  EXECUTE_TIME_PANEL = 'execute-time-panel',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  ORAL_DIET_CONTENT_PANEL = 'oral-diet-content-panel',
  ORAL_DIET_DETAILS_CARD = 'oral-diet-details-card',
  ORAL_DIET_FOOTER_PANEL = 'oral-diet-footer-panel',
  ORAL_DIET_VIEWER_CONTEXTUAL_BAR = 'oral-diet-viewer-contextual-bar',
  ORAL_DIET_VIEWER_DECK = 'oral-diet-viewer-deck',
  ORAL_DIET_VIEWER_LAYOUT = 'oral-diet-viewer-layout',
  PANEL_HEADER = 'panel-header',
}
export { OralDietViewerAliases };
